import React from "react";
import { TCaseMilestoneType, TCaseTimelineMilestoneEntry } from "../../../../domain/codecs/form/CaseTimelineForm";
import { SpacingRow } from "../BuildingBlocks/SpacingRow";
import { CRMRoadblockActionLog } from "../CRMRoadblock/CRMRoadblockActionLog/CRMRoadblockActionLog";
import { requireExhaustive } from "../../../../shared/src/util";

type TCaseTimelineMilestoneProps = {
    entry: TCaseTimelineMilestoneEntry;
};

const getLabel = (milestoneType: TCaseMilestoneType): string => {
    switch (milestoneType) {
        case "instructed":
            return "Case instructed";
        case "exchanged":
            return "Contracts exchanged";
        case "completed":
            return "Case completed";
        case "abandoned":
            return "Case closed before completion";
        default:
            return requireExhaustive(milestoneType);
    }
};

const getPillType = (milestoneType: TCaseMilestoneType): "blue-pill" | "green-pill" | "grey-pill" => {
    switch (milestoneType) {
        case "instructed":
        case "exchanged":
            return "blue-pill";
        case "completed":
            return "green-pill";
        case "abandoned":
            return "grey-pill";
        default:
            return requireExhaustive(milestoneType);
    }
};

export const CRMCaseTimelineMilestone = (props: React.PropsWithChildren<TCaseTimelineMilestoneProps>): JSX.Element => (
    <SpacingRow justifyContent="center">
        <CRMRoadblockActionLog type={getPillType(props.entry.action.milestone_type)}>
            {getLabel(props.entry.action.milestone_type)}
        </CRMRoadblockActionLog>
    </SpacingRow>
);
